/*eslint-disable*/
import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import signupPageStyle from "assets/jss/material-kit-pro-react/views/signupPageStyle.js";
import { isEmpty } from "lodash";
import EmailDetailsConfirm from "../../views/EmailConfirmationPage/Classes/EmailConfirmDetails.js";
import { useParams } from 'react-router-dom';
import LoadingData from '../lottieLoading.js';

const useStyles = makeStyles(signupPageStyle);
import { useHistory } from "react-router-dom";

export default function EmailConfirmation({ ...rest }) {
    const [verified, setVerified] = useState(false);
    const { id } = useParams('');


    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        peformConfirmationCheck();
    }, []);

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    let token = params.token; 

    let userEmail = params.email; 

    const classes = useStyles();

    let history = useHistory();


    async function peformConfirmationCheck() {
        try {
         

            if (!isEmpty(token)) {
                const response = await fetch('api/auth/confirmemailUser/', {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ConfirmationCode: token,
                        EmailAddress: userEmail
                    })
                })
                    .then((response) => {
                        if (response.status === 401) {
                            throw new Error("Unauthorised request");
                        }
                        return response;
                    })
                    .then(res => res.json())
                    .catch();


                if (response) {
                    setVerified(true)
                }
                else {
                    setVerified(false)
                    history.push("/error-page")

                }
            }
            else {
                // redirect to 404 page
            }
        }
        catch (error) {
        };
    }


    if (verified) {
        return (
            <div className={classes.container}>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={10} md={10}>
                        <Card className={classes.cardSignup}>
                            <EmailDetailsConfirm userEmail={userEmail} />
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );

    }

    else {
        return (<LoadingData text={"Verifying Account Please..."} />);
    }




}
